import { COMMENT_MODEL_KEY_POINTER } from 'models/daos/comment/constants'

const COMMENTS_DOMAIN = 'comments'
const COMMENTS_STATE = {
  /**
   * A mapping of `Article` slug to `DomainList`.
   *
   * @example
   *
   * ```js
   *
   * comment : {
   *
   *   articles : {
   *     'how-to-stay-healthy-at-the-grocery-store' : {
   *        data : [1, 2, 3],
   *        new  : -40
   *     }
   *   }
   *
   *   data : {
   *
   *    -40 : {
   *      className : 'Comment',
   *      data      : {
   *        ...
   *      },
   *      ...
   *    }
   *
   *   }
   *
   * }
   *
   * ```
   *
   * @type {Object}
   */
  articles: {},
  /**
   * A mapping of `Motivation` key to `DomainList`.
   * @type {Object}
   */
  motivation: {},
  /**
   * A mapping of `Comment` id to `DomainList`.
   * @type {Object}
   */
  comments: {},
  /**
   * A mapping of `Comment`'s id to `Instance`.
   * @type {Object}
   */
  data: {}
}

const COMMENTS_DOMAIN_MAP_KEY = COMMENT_MODEL_KEY_POINTER
const COMMENTS_PATH = {
  DATA: `${COMMENTS_DOMAIN}.data`
}

export {
  COMMENTS_DOMAIN,
  COMMENTS_DOMAIN_MAP_KEY,
  COMMENTS_PATH,
  COMMENTS_STATE
}
